export default {
  feedback: {
    success: 'Mobiele app succesvol opgeslagen',
    error: 'Mobiele app opslaan mislukt',
  },
};
